<app-menu-buttons-page
  label="Recomendaciones"
  [topActions]="topActions"
  [backgroundImage]="backgroundImage"
  (actionClick)="onActionClick($event)"
>
</app-menu-buttons-page>
